/**
 * Environment policy for draft content previews and compact menu layout.
 * Page links independently require published flags in every environment.
 *
 * - Local dev and test: allow draft content previews.
 * - Vercel preview (`VERCEL_ENV=preview`): allow drafts for QA.
 * - Production deploy (`NODE_ENV=production`, not preview): hide drafts.
 */
export function shouldHideUnpublishedNavItems(): boolean {
  if (process.env.NODE_ENV !== "production") {
    return false;
  }
  if (process.env.VERCEL_ENV === "preview") {
    return false;
  }
  return true;
}

/** Inverse helper for readability at call sites. */
export function showUnpublishedNavItems(): boolean {
  return !shouldHideUnpublishedNavItems();
}

type ServicesNavMegaColumn = Readonly<{ links: ReadonlyArray<unknown> }>;

/**
 * Production uses a compact top-level service list only when every mega column
 * has zero published sub-links (avoids an empty stub grid). When any column
 * has live sub-pages (e.g. HubSpot under AI automation), show the full grid.
 */
export function shouldUseCompactServicesNav(
  megaColumns?: ReadonlyArray<ServicesNavMegaColumn>,
): boolean {
  if (!shouldHideUnpublishedNavItems()) {
    return false;
  }
  if (megaColumns?.some((column) => column.links.length > 0)) {
    return false;
  }
  return true;
}
